<dialog-draggable-header>File Upload Summary</dialog-draggable-header>

<data-table [data]="fileData" [columns]="columns" (lazyLoad)="onLazyLoad($event)" [lazy]="true" [paging]="true"
  [pageSize]="pageOptions.size" [totalRecords]="total" [filterable]="false" [filterColumnDisplay]="false">
  <ng-container actionStart>
    <button mat-button (keydown.enter)="exportExcel()" (click)="exportExcel()">MS Excel Report</button>
  </ng-container>
  <ng-container actionEnd>
    <button mat-button (keydown.enter)="close()" (click)="close()">Close</button>
  </ng-container>
</data-table>